import { render, staticRenderFns } from "./EditReportComment.vue?vue&type=template&id=35fa069c&"
import script from "./EditReportComment.vue?vue&type=script&lang=js&"
export * from "./EditReportComment.vue?vue&type=script&lang=js&"
import style0 from "./EditReportComment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports